import { createApi } from '@reduxjs/toolkit/query/react';

import {
  SalesFunnelStageLeadEndpoints as Endpoints,
  type AddOrExchangeRangeBySearchIdSalesFunnelStageLeadRequest,
  type AddOrExchangeRangeBySearchIdSalesFunnelStageLeadResponse,
  type AddOrExchangeRangeSalesFunnelStageLeadRequest,
  type AddOrExchangeRangeSalesFunnelStageLeadResponse,
  type AddSalesFunnelStageLeadRequest,
  type AddSalesFunnelStageLeadResponse,
  type DeleteSalesFunnelStageLeadRequest,
  type DeleteSalesFunnelStageLeadResponse,
  type ExchangeSalesFunnelStageLeadRequest,
  type ExchangeSalesFunnelStageLeadResponse,
} from '@app/api/SalesFunnelStageLead/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { SALES_FUNNELS_STAGES_CHUNK } from '@app/constants';

export const salesFunnelStageLeadApi2 = createApi({
  reducerPath: 'salesFunnelStageLeadApi2',
  baseQuery: createApiBaseQuery(`${SALES_FUNNELS_STAGES_CHUNK}/Leads`),
  endpoints: ({ mutation }) => ({
    [Endpoints.Add]: mutation<
      AddSalesFunnelStageLeadResponse,
      AddSalesFunnelStageLeadRequest
    >({
      query: (params) => ({
        url: Endpoints.Add,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.AddOrExchangeRange]: mutation<
      AddOrExchangeRangeSalesFunnelStageLeadResponse,
      AddOrExchangeRangeSalesFunnelStageLeadRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.AddOrExchangeRange,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.AddOrExchangeRangeBySearchId]: mutation<
      AddOrExchangeRangeBySearchIdSalesFunnelStageLeadResponse,
      AddOrExchangeRangeBySearchIdSalesFunnelStageLeadRequest
    >({
      query: (params) => ({
        url: Endpoints.AddOrExchangeRangeBySearchId,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.Exchange]: mutation<
      ExchangeSalesFunnelStageLeadResponse,
      ExchangeSalesFunnelStageLeadRequest
    >({
      query: ({ leadId, ...params }) => ({
        url: `${Endpoints.Exchange}/${leadId}`,
        method: Methods.PUT,
        params,
      }),
    }),
    [Endpoints.Delete]: mutation<
      DeleteSalesFunnelStageLeadResponse,
      DeleteSalesFunnelStageLeadRequest
    >({
      query: ({ leadId, ...params }) => ({
        url: `${Endpoints.Delete}/${leadId}`,
        method: Methods.DELETE,
        params,
      }),
    }),
  }),
});

export const {
  useAddMutation,
  useAddOrExchangeRangeMutation,
  useAddOrExchangeRangeBySearchIdMutation,
  useExchangeMutation,
  useDeleteMutation,
} = salesFunnelStageLeadApi2;
